import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';

import Button from '@/components/Button';

export const StyledLoginForm = styled.View`
  padding-top: ${dynamicSize.convertSize(30)}px;
  padding-bottom: ${dynamicSize.convertSize(10)}px;
`;

export const StyledLoginFormField = styled.View`
  padding-bottom: ${dynamicSize.convertSize(10)}px;
`;

export const StyledLoginFormActions = styled.View`
  flex-direction: row;
  padding-top: ${dynamicSize.convertSize(10)}px;
`;

export const StyledLoginFormButton = styled(Button)`
  flex: 1;
`;
